import { render, staticRenderFns } from "./PaymentTransfer.vue?vue&type=template&id=aa1afc60&scoped=true"
import script from "./PaymentTransfer.vue?vue&type=script&lang=js"
export * from "./PaymentTransfer.vue?vue&type=script&lang=js"
import style0 from "./PaymentTransfer.vue?vue&type=style&index=0&id=aa1afc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1afc60",
  null
  
)

export default component.exports